module.exports = __webpack_public_path__ + "assets/img/15.a587df35.png";